// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-list-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.89 3.953a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0zm3.454 4.026a4.54 4.54 0 0 0-.532-.042 4.781 4.781 0 0 0-4.78 4.782' />
    <path
      fill='currentColor'
      d='M15.906 8.469s1.063 0 1.063 1.062v6.375s0 1.063-1.063 1.063H9.531s-1.062 0-1.062-1.063V9.531s0-1.062 1.062-1.062zm-5.312 5.375a1 1 0 1 0 0 2h1.594a1 1 0 0 0 0-2zm0-2.125a1 1 0 1 0 0 2h4.25a1 1 0 0 0 0-2zm0-2.125a1 1 0 0 0 0 2h4.25a1 1 0 0 0 0-2z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
